export default __webpack_public_path__ + "static/media/Mint2.b5f950a1.png";